<em [ngClass]="{'color-white': colorWhite}" class="material-icons">{{ iconName }}</em>
